import React, { useEffect, useState } from 'react';
import { Button, TextField } from "@material-ui/core";
import ActionButton from "../components/layout/actionButtons";
import SettingsService from '../services/settings';
export default function Settings(props) {

    const [settings, setSettings] = useState({});

    let handleSave = () => {
        SettingsService.save(settings);
    }
   
    useEffect(() => {
        props.handleMenu(
            {
                title: 'Instellingen ARAL werkbon',
            });
            getSettings();
    }, [])

    const handleSaveItem = (ev)=>{
        let tmpItem = Object.assign({},settings);
        tmpItem[ev.target.id] = ev.target.value;
        setSettings(tmpItem)
        console.log('save',settings)
    }
   const getSettings = () =>{

        SettingsService.get().then(
          (settings) => {
            setSettings( settings );
          }, (err) => { });
    
      }
    return (
        <div className="padding">
            <TextField
                multiline
                margin="dense"
                id="emailadministration"
                label="Email administratie"
                type="text"
                value={settings.emailadministration || ""}
                onChange={handleSaveItem}
                onBlur={handleSave}
                fullWidth
            />
              <TextField
                multiline
                margin="dense"
                id="remindermail"
                label="Herinnering werkbon nog in concept"
                type="text"
                value={settings.remindermail || ""}
                onChange={handleSaveItem}
                onBlur={handleSave}
                fullWidth
            />
              <TextField
                multiline
                margin="dense"
                id="confirmationmail"
                label="Bevestiging verzonden werkbon"
                type="text"
                value={settings.confirmationmail || ""}
                onChange={handleSaveItem}
                onBlur={handleSave}
                fullWidth
            />
              <TextField
                multiline
                margin="dense"
                id="changestatusmail"
                label="Bevestiging verandering van status werkbon"
                type="text"
                value={settings.changestatusmail || ""}
                onChange={handleSaveItem} 
                onBlur={handleSave}
                fullWidth
            />
        </div>
    )
}